<div
  class="body-wrapper"
  *ngIf="print.loaded"
  [ngClass]="Direction"
  style="padding-top: 0"
>
  <!-- ========================== Header (Start) ========================== -->
  <header class="header">
    <div
      class="justify-between items-center"
      [innerHtml]="altHeader"
      *ngIf="altHeader && showHeader"
      style="width: 100%"
    ></div>
    <div
      class="justify-between items-center"
      *ngIf="print.env && print.env['haslogo'] && false"
    >
      <img [src]="!print.env['haslogo'] ? '' : '/api/logo'" alt="Logo" />
    </div>
    <div class="justify-between items-center" style="margin-bottom: 5px">
      <h1 *ngIf="!print.isForm" class="header-title" style="color: #000">
        {{
          (print.isOBS
            ? print.exam.Changed
              ? titleArray.includes(print.exam.ChangedExamTitle)
                ? "exam.type.OBS." + print.exam.ChangedExamTitle
                : print.exam.ChangedExamTitle
              : "exam.type.OBS." + print.exam.ExamType
            : print.isForm
              ? "forms." + print.Forms[0].Title
              : print.exam.ExamType === "OCT"
                ? "eyes.OCTPrint"
                : "exam.type.Eyes.print." + print.exam.ExamType
          ) | translate
        }}
      </h1>
      <h1
        *ngIf="print.isForm && print.Forms[0].Title"
        class="header-title"
        style="color: #000"
      >
        {{ "forms." + print.Forms[0].Title | translate }}
      </h1>
      <h1
        *ngIf="
          print.isForm &&
          print.Forms[0].selectedTemplate &&
          !print.Forms[0].Title
        "
        class="header-title"
        style="color: #000"
      >
        {{ print.Forms[0].selectedTemplate }}
      </h1>
      <img
        [src]="
          !print.env['haslogo'] ? '../../assets/images/logo.png' : '/api/logo'
        "
        alt="Logo"
        class="header-logo"
        *ngIf="print.env && !altHeader && print.env['haslogo']"
      /><!-- uncommented this for the old style user logos-->
    </div>
    <div class="header-details">
      <div style="display: inline-block; padding-left: 1em; padding-right: 1em">
        {{
          (print.isForm ? "general.date" : "general.ExaminationDate")
            | translate
        }}:&nbsp;<strong style="direction: ltr">{{
          print.exam.CreationTime | date: "dd.MM.yyyy HH:mm"
        }}</strong>
      </div>
      <div style="display: inline-block">
        {{ "general.Printing_Date" | translate }}:&nbsp;<strong
          style="direction: ltr"
          >{{ now | date: "dd.MM.yyyy HH:mm" }}</strong
        >
      </div>
    </div>
  </header>
  <!-- ========================== Header (End) ========================== -->
  <main class="main" [ngClass]="typeOfPrint">
    <!-- ========================== Patient Details (Start) ========================== -->
    <section class="section" *ngIf="print.Pat">
      <h4 class="text-20 text-gold" *ngIf="!print.isForm">
        {{ "general.ExamDetails" | translate }}
      </h4>
      <h4 class="text-20 text-gold" *ngIf="print.isForm">
        {{ "general.Patient.Patient_Details" | translate }}
      </h4>

      <div style="width: 100%">
        <div style="width: 100%">
          <div style="display: inline-flex">
            <table>
              <tr>
                <td>
                  <dt>{{ "general.Patient.first_name" | translate }} :</dt>
                  <dd style="font-size: 20px">
                    <strong>{{ print.Pat.First }}</strong>
                  </dd>
                </td>
                <td>
                  <dt>{{ "general.Patient.last_name" | translate }}:</dt>
                  <dd style="font-size: 20px">
                    <strong>{{ print.Pat.Last }}</strong>
                  </dd>
                </td>
                <td>
                  <dt>{{ "general.Patient.ID" | translate }}:</dt>
                  <dd>{{ print.Pat.ID }}</dd>
                </td>
                <td *ngIf="print.Pat.Birth">
                  <dt>{{ "general.Patient.birth_date" | translate }}:</dt>
                  <dd>{{ print.Pat.Birth | date: "dd.MM.yyyy" }}</dd>
                </td>
                <td *ngIf="print.Pat.Birth">
                  <dt>{{ "general.Patient.Age" | translate }}:</dt>
                  <dd>{{ print.Pat.getAgeMo() }}</dd>
                </td>
                <td *ngIf="print.Pat.Mobile">
                  <dt>{{ "general.Patient.mobile" | translate }}:</dt>
                  <dd>{{ print.Pat.Mobile }}</dd>
                </td>
                <td *ngIf="print.Pat.Address">
                  <dt>{{ "general.Patient.address" | translate }}:</dt>
                  <dd>{{ print.Pat.Address }}</dd>
                </td>
              </tr>
            </table>
            <div
              *ngIf="typeOfPrint === 'fancy'"
              class="flex justify-center items-center ps-24"
              style="width: 20%"
            >
              <img
                src="../../assets/images/girl.svg"
                width="111"
                height="154"
                alt="Patient Icon"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- ========================== Patient Details (End) ========================== -->

    <!-- ========================== Referral Request (Start) ========================== -->
    <section class="section" *ngIf="print.eyesGeneral.referralRequest">
      <div class="section-text" style="width: 100%">
        <h4 class="text-20 text-gold">
          {{ "eyes.referral Request" | translate }}
        </h4>
        <table>
          <tr>
            <td class="td-med">
              <dt
                class="dt-med"
                [ngClass]="Direction === 'ltr' ? 'dt-ltr' : 'dt-rtl'"
              >
                {{ print.eyesGeneral.referralRequest }}
              </dt>
            </td>
          </tr>
        </table>
      </div>
    </section>
    <!-- ========================== Referral Request (End) ========================== -->
    <!-- ========================== Software (Start) ========================== -->
    <section class="section" *ngIf="print.eyesGeneral.software">
      <div class="section-text" style="width: 100%">
        <h4 class="text-20 text-gold">{{ "eyes.software" | translate }}</h4>
        <table>
          <tr>
            <td class="td-med">
              <dt
                class="dt-med"
                [ngClass]="Direction === 'ltr' ? 'dt-ltr' : 'dt-rtl'"
              >
                {{ print.eyesGeneral.software }}
              </dt>
            </td>
          </tr>
        </table>
      </div>
    </section>
    <!-- ========================== Software (End) ========================== -->
    <!-- ========================== Medical History (Start) ========================== -->
    <section class="section" *ngIf="print.eyesGeneral.MedicalHistory">
      <div class="section-text" style="width: 100%">
        <h4 class="text-20 text-gold">
          {{ "eyes.MedicalHistory" | translate }}
        </h4>
        <table>
          <tr>
            <td class="td-med">
              <dt
                class="dt-med"
                [ngClass]="Direction === 'ltr' ? 'dt-ltr' : 'dt-rtl'"
              >
                {{ print.eyesGeneral.MedicalHistory }}
              </dt>
            </td>
          </tr>
        </table>
      </div>
    </section>
    <!-- ========================== Medical History (End) ========================== -->
    <!-- ========================== Tech Comment (Start) ========================== -->
    <section class="section" *ngIf="print.eyesGeneral.TechComment">
      <div class="section-text" style="width: 100%">
        <h4 class="text-20 text-gold">{{ "eyes.TechComment" | translate }}</h4>
        <table>
          <tr>
            <td class="td-med">
              <dt
                class="dt-med"
                [ngClass]="Direction === 'ltr' ? 'dt-ltr' : 'dt-rtl'"
              >
                {{ print.eyesGeneral.TechComment }}
              </dt>
            </td>
          </tr>
        </table>
      </div>
    </section>
    <!-- ========================== Tech Comment (End) ========================== -->

    <!-- ========================== Findings (Start) ========================== -->
    <div
      style="width: 100%"
      *ngIf="
        print.eyesGeneral.LeftEyeFov ||
        print.eyesGeneral.RightEyeFov ||
        print.eyesGeneral.LeftEyeMacular ||
        print.eyesGeneral.RightEyeMacular ||
        print.eyesGeneral.LeftEyeNerve ||
        print.eyesGeneral.RightEyeNerve
      "
    >
      <section class="section" style="padding: 1em">
        <h1 class="text-20 text-gold">{{ "eyes.Findings" | translate }}:</h1>
        <!-- ==================== Field of View (Start) ==================== -->
        <div class="flex">
          <section class="section w50" *ngIf="print.eyesGeneral.RightEyeFov">
            <div class="section-text" style="width: 100%">
              <h4 class="text-20 text-gold">
                {{ "eyes.RightEye" | translate }}
              </h4>
              <table>
                <tr>
                  <td class="td-med">
                    <dt
                      class="dt-med"
                      [ngClass]="Direction === 'ltr' ? 'dt-ltr' : 'dt-rtl'"
                    >
                      {{ print.eyesGeneral.RightEyeFov }}
                    </dt>
                  </td>
                </tr>
              </table>
            </div>
          </section>
          <section class="section w50" *ngIf="print.eyesGeneral.LeftEyeFov">
            <div class="section-text" style="width: 100%">
              <h4 class="text-20 text-gold">
                {{ "eyes.LeftEye" | translate }}
              </h4>
              <table>
                <tr>
                  <td class="td-med">
                    <dt
                      class="dt-med"
                      [ngClass]="Direction === 'ltr' ? 'dt-ltr' : 'dt-rtl'"
                    >
                      {{ print.eyesGeneral.LeftEyeFov }}
                    </dt>
                  </td>
                </tr>
              </table>
            </div>
          </section>
        </div>
        <!-- ==================== Field of View (End) ==================== -->
        <br />
        <!-- ==================== Macular (Start) ==================== -->
        <h3
          *ngIf="
            print.eyesGeneral.LeftEyeMacular ||
            print.eyesGeneral.RightEyeMacular
          "
        >
          {{ "eyes.Macular" | translate }}
        </h3>
        <div class="flex">
          <section
            class="section w50"
            *ngIf="print.eyesGeneral.RightEyeMacular"
          >
            <div class="section-text" style="width: 100%">
              <h3>{{ "eyes.RightEye" | translate }}</h3>
              <table>
                <tr>
                  <td class="td-med">
                    <dt
                      class="dt-med"
                      [ngClass]="Direction === 'ltr' ? 'dt-ltr' : 'dt-rtl'"
                    >
                      {{ print.eyesGeneral.RightEyeMacular }}
                    </dt>
                  </td>
                </tr>
              </table>
            </div>
          </section>
          <section class="section w50" *ngIf="print.eyesGeneral.LeftEyeMacular">
            <div class="section-text" style="width: 100%">
              <h3>{{ "eyes.LeftEye" | translate }}</h3>
              <table>
                <tr>
                  <td class="td-med">
                    <dt
                      class="dt-med"
                      [ngClass]="Direction === 'ltr' ? 'dt-ltr' : 'dt-rtl'"
                    >
                      {{ print.eyesGeneral.LeftEyeMacular }}
                    </dt>
                  </td>
                </tr>
              </table>
            </div>
          </section>
        </div>
        <!-- ==================== Macular (End) ==================== -->
        <!-- ==================== Nerve (Start) ==================== -->
        <h3
          *ngIf="
            print.eyesGeneral.LeftEyeNerve || print.eyesGeneral.RightEyeNerve
          "
        >
          {{ "eyes.Nerve" | translate }}
        </h3>
        <div class="flex">
          <section class="section w50" *ngIf="print.eyesGeneral.RightEyeNerve">
            <div class="section-text" style="width: 100%">
              <h3>{{ "eyes.RightEye" | translate }}</h3>
              <table>
                <tr>
                  <td class="td-med">
                    <dt
                      class="dt-med"
                      [ngClass]="Direction === 'ltr' ? 'dt-ltr' : 'dt-rtl'"
                    >
                      {{ print.eyesGeneral.RightEyeNerve }}
                    </dt>
                  </td>
                </tr>
              </table>
            </div>
          </section>
          <section class="section w50" *ngIf="print.eyesGeneral.LeftEyeNerve">
            <div class="section-text" style="width: 100%">
              <h3>{{ "eyes.LeftEye" | translate }}</h3>
              <table>
                <tr>
                  <td class="td-med">
                    <dt
                      class="dt-med"
                      [ngClass]="Direction === 'ltr' ? 'dt-ltr' : 'dt-rtl'"
                    >
                      {{ print.eyesGeneral.LeftEyeNerve }}
                    </dt>
                  </td>
                </tr>
              </table>
            </div>
          </section>
        </div>
        <!-- ==================== Nerve (End) ==================== -->
      </section>
    </div>
    <!-- ========================== Findings (End) ========================== -->

    <!-- ========================== Summary (Start) ========================== -->
    <section class="section summary" *ngIf="print.eyesGeneral.SummaryHtml">
      <div class="comment section-inner">
        <h3>{{ "summary.title" | translate }}:</h3>
        <span [innerHtml]="print.eyesGeneral.SummaryHtml"></span>
      </div>
    </section>
    <!-- ========================== Summary (End) ========================== -->

    <!-- ========================== Terms (Start) ========================== -->
    <section class="section summary" *ngIf="print.eyesGeneral.Terms">
      <div class="comment section-inner">
        <h3>{{ "summary.Terms" | translate }}</h3>
        <span>{{ print.eyesGeneral.Terms }}</span>
      </div>
    </section>
    <!-- ========================== Terms (End) ========================== -->

    <!-- ========================== Signatures (Start) ========================== -->
    <section class="section" *ngIf="!print.Forms">
      <table>
        <tr *ngFor="let signer of print.signers; let i = index">
          <!-- ==================== Performed By (Start) ==================== -->
          <div
            *ngIf="
              signer.Signer !== signer.OpenerTitle + ' ' + signer.OpenerName
            "
            style="margin: 0 0 1em 0"
          >
            <strong> {{ "eyes.PerformedBy" | translate }}: </strong>
            <strong> {{ signer.Title }} {{ signer.OpenerName }} </strong>
            <td *ngIf="signer.Signer !== signer.OpenerName" class="w-1/3">
              <span>
                {{ print.exam.CreationTime | date: "d-M-y H:mm:ss" }}
              </span>
            </td>
          </div>
          <!-- ==================== Performed By (End) ==================== -->

          <!-- ==================== Reviewed By (Start) ==================== -->
          <div *ngIf="signer.Signer" style="white-space: pre">
            <strong> {{ "eyes.ReviewedBy" | translate }}: </strong>
            <strong>
              {{ signer.Signer }}
            </strong>
            <td class="w-1/3">
              <span>
                {{ print.exam.ClosedDate | date: "d-M-y H:mm:ss" }}
              </span>
              <ng-container *ngIf="signer.license">
                מ.ר.
                <strong>
                  {{ signer.license }}
                </strong>
              </ng-container>
              <ng-container *ngIf="signer.ExpertNum"
                >מ.ר.מ.
                <strong>
                  {{ signer.ExpertNum }}
                </strong>
              </ng-container>
            </td>
          </div>
          <!-- ==================== Reviewed By (End) ==================== -->
        </tr>
      </table>
    </section>
    <ng-container *ngFor="let signer of print.signers">
      <img
        *ngIf="signer['signature']"
        [src]="'assets/signatures/' + signer['signature']"
        style="max-height: 100px; break-inside: avoid"
      />
    </ng-container>
    <!-- ========================== Signatures (End) ========================== -->

    <!-- ========================== Print Images (Start) ========================== -->
    @if (hasImages && allImages.length > 0) {
      @for (page of imagePages; track $index; let last = $last) {
        <div
          class="image-page"
          [style.grid-template-columns]="'repeat(' + imageCols + ', 1fr)'"
          [style.grid-template-rows]="'repeat(' + imageRows + ', 1fr)'"
          [style.page-break-after]="last ? 'auto' : 'always'"
        >
          @for (image of page; track $index) {
            <div class="image-cell">
              <img [src]="image.src" />
            </div>
          }
        </div>
      }
    }
    <!-- ========================== Print Images (End) ========================== -->
    <span class="finished" *ngIf="loaded"></span>
  </main>
</div>
